import ConfirmationModal from 'components/organisms/confirmation-modal';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { DueDiligenceDeleteModalProps } from './types';
import { useFetch } from 'hooks';
import { useAuth } from 'auth';
import { useConfig } from 'config';

const DueDiligenceDeleteModal: React.FC<DueDiligenceDeleteModalProps> = ({
  isOpen,
  onClose,
  screeningId,
  isMDD,
  thirdPartyId,
}) => {
  const { tokenInfo } = useAuth();
  const { vantageWebApi } = useConfig();
  const [loadingStatus, setLoadingStatus] = useState<string>('not started');
  const [title, setTitle] = useState<string>('Are you sure?');
  const [message, setMessage] = useState<string>('');
  const history = useHistory();

  useEffect(() => {
    let message = 'Please note that this will delete the selected case and associated report.';
    if (isMDD) {
      message =
        'Please note that this will delete the selected case and associated report.  If the report is currently “In progress” the order will be cancelled and there may be a cost for this.  A member of the Control Risks team will contact you to discuss.';
    }
    setMessage(message);
  }, [isMDD]);

  const { loading, trigger: triggerDelete } = useFetch(
    `${vantageWebApi}/onlinescreening/${screeningId}`,
    {
      method: 'DELETE',
      lazy: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenInfo.accessToken}`,
      },
    }
  );

  useEffect(() => {
    if (loading) {
      setLoadingStatus('started');
      setTitle('Deleting, please wait');
    }
    if (!loading && loadingStatus === 'started') {
      setLoadingStatus('completed');
    }
    if (loadingStatus === 'completed') {
      setLoadingStatus('not started');
      setTitle('Deleted, reloading page');
      setMessage('');
      history.push(`/third-party/profile/${thirdPartyId}`);
      history.go(0);
    }
  }, [loading, loadingStatus, history, thirdPartyId]);

  const handleProceed = (): void => {
    if (screeningId == null) {
      return;
    }
    triggerDelete();
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onClose}
      title={title}
      onProceed={handleProceed}
      message={message}
      loading={loading}
    ></ConfirmationModal>
  );
};

export default DueDiligenceDeleteModal;
